<template>
  <section class="flex-1">
    <lazy-dom>
      <div class="policy-form width-700">
        <el-form
          ref="form"
          :rules="formRules"
          :disabled="showBuyable"
          :model="formData">
          <div
            v-if="isCancel"
            class="box">
            <h3></h3>
            <div
              class="flex-sb">
              <div class="form-item form-half">
                <span>Cancellation Effective Date</span>
                <el-form-item
                  ref="pcy_expry_dt"
                  :prop="checkRefer===1?'':'pcy_expry_dt'">
                  <v-date-picker
                    v-model="formData.pcy_expry_dt"
                  />
                </el-form-item>

              </div>
            </div>
          </div>
          <div class="box">
            <h3>Policy Details</h3>
            <div
              v-if="!isCancel"
              class="flex-sb">
              <div class="form-item form-half">
                <span>{{ isCancel? 'Cancellation Effective Date':(isEndorsement? 'Endorsement Effective Date': 'Expected  Effective Date') }}</span>
                <el-form-item
                  v-if="isCancel"
                  ref="pcy_expry_dt"
                  :prop="checkRefer===1?'':'pcy_expry_dt'">
                  <v-date-picker
                    v-model="formData.pcy_expry_dt"
                  />
                </el-form-item>
                <el-form-item
                  v-else
                  ref="pcy_cmnt_dt"
                  :prop="checkRefer===1?'':'pcy_cmnt_dt'">
                  <v-date-picker
                    v-model="formData.pcy_cmnt_dt"
                  />
                </el-form-item>
              </div>
            </div>
            <!--            <div class="flex-sb">-->
            <!--              <div class="form-item form-half">-->
            <!--                <span>Effective date</span>-->
            <!--                <el-form-item-->
            <!--                  prop="pcy_cmnt_dt">-->
            <!--                  <v-date-picker v-model="formData.pcy_cmnt_dt" />-->
            <!--                </el-form-item>-->
            <!--              </div>-->

            <!--            </div>-->
            <div
              v-if="!isCancel"
              class="form-item form-half">
              <span>Expected Expiry Date</span>
              <el-form-item
              >
                <v-date-picker
                  :value="expry_date"
                  disabled/>
              </el-form-item>

            </div>
            <div class="form-item form-half">
              <span>Studying Country</span>
              <el-form-item prop="country_id">
                <v-select
                  v-model="formData.country_id"
                  :disabled="isCancel"
                  :list="localAllOptions.study_country" />
              </el-form-item>
              <el-form-item
                v-if="formData.country_id==3"
                class="margin-top"
                prop="other_country">
                <v-input
                  v-model="formData.other_country"
                  :disabled="checkDisabled('other_country')"
                />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="isRefer&&insuredItems.length>0"
            class="box">
            <h3>Insured Items</h3>
            <div class="form-item form-half option_checkout">
              <v-checkbox-group
                v-model="formData.benefits"
                :block="true"
                :list="insuredItems" />
            </div>
          </div>
          <div
            v-if="benefitList.length>0&&!isRefer"
            class="box">
            <!--          <h2>Insured Items</h2>-->
            <div
              class="form-item form-half extra_checkbox">
              <span>Insured Items</span>
              <el-form-item
              >
                <v-checkbox-group
                  v-model="formData.benefits"
                  :list="benefitList"
                  @change="handlerExtra"
                />
              </el-form-item>
            </div>
          </div>
          <div class="box">
            <h3>Policyholder Details</h3>
            <div class="form-item form-half">
              <span>Title</span>
              <el-form-item prop="isrd_title">
                <v-select
                  v-model="formData.isrd_title"
                  :disabled="isCancel||checkDisabled('isrd_title')"
                  :list="titleOptions" />
              </el-form-item>
            </div>
            <div class="flex-sb">
              <div class="form-item form-half">
                <span>Last Name</span>
                <el-form-item prop="isrd_lst_nm">
                  <v-input
                    v-model="formData.isrd_lst_nm"
                    uppercase
                    :disabled="isCancel||checkDisabled('isrd_lst_nm')"/>
                </el-form-item>
              </div>

            </div>
            <div class="form-item form-half">
              <span>First Name</span>
              <el-form-item prop="isrd_fst_nm">
                <v-input
                  v-model="formData.isrd_fst_nm"
                  uppercase
                  :disabled="isCancel||checkDisabled('isrd_fst_nm')"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Date of Birth</span>
              <el-form-item prop="isrd_dob">
                <v-birth-day
                  v-model="formData.isrd_dob"
                  :disabled="isCancel||checkDisabled('isrd_dob')"
                />
              </el-form-item>
            </div>
            <div class="form-half">
              <div class="form-item">
                <span>{{formData.id_type==2?'Passport':'HKID'}} Number</span>
                <el-form-item
                  ref="id_type"
                >
                  <v-radio-group
                    v-model="formData.id_type"
                    :disabled="isCancel||checkDisabled('id_type')"
                    :list="personalIdTypOptions" />
                </el-form-item>
                <el-form-item
                  v-if="formData.id_type==1"
                  prop="id_no"
                >
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    :disabled="isCancel||checkDisabled('id_no')"
                    placeholder="A123456(3), please input A1234563"
                    class="mg-t-5" />
                </el-form-item>
                <el-form-item
                  v-else
                  ref="pp_no"
                >
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    :disabled="checkDisabled('id_no')"
                    class="mg-t-5" />
                </el-form-item>
              </div>
            </div>
            <div class="form-item form-half">
              <span>Mobile Number</span>
              <el-form-item prop="mobile_no">
                <v-input
                  v-model="formData.mobile_no"
                  :disabled="isCancel||checkDisabled('mobile_no')"
                  type="number"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Email</span>
              <el-form-item
                ref="email"
                prop="email"
                :rules="rules.email">
                <v-input
                  v-model="formData.email"
                  :disabled="isCancel||checkDisabled('email')"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Occupation</span>
              <el-form-item prop="occ_id">
                <v-select
                  v-model="formData.occ_id"
                  :disabled="isCancel||checkDisabled('occ_id')"
                  :list="localAllOptions.occupation"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Policyholder and student is the same person?</span>
              <el-form-item prop="hldr_is_student_ind">
                <v-radio-group
                  v-model="formData.hldr_is_student_ind"
                  :border="true"
                  :disabled="isCancel"
                  :list="yesNoOptions"
                  @change="handlerSamePolicyInfo" />
              </el-form-item>
            </div>
            <span class="title">Correspondence Address</span>
            <address-form
              ref="address-form"
              :formType="1"
              :formDataLock="formDataLock"
              :form="addressForm"
              :disabled="isCancel||showBuyable"
              :not-valid="checkRefer===1?true:false"
              @getFormData="getAddressForm" />
          </div>

          <div class="box">
            <h3>Insured Student Details</h3>
            <div class="form-item form-half">
              <span>Title</span>
              <el-form-item
                ref="student_info.student_title"
                :rules="!isRules?[]:rules.student_title"
                prop="student_info.student_title">
                <v-select
                  v-model="formData.student_info.student_title"
                  :disabled="isCancel||isDisable"
                  :list="titleOptions" />
              </el-form-item>
            </div>
            <div class="flex-sb">
              <div class="form-item form-half">
                <span>Last Name</span>
                <el-form-item
                  ref="student_info.student_lst_nm"
                  :rules="!isRules?[]:rules.student_lst_nm"
                  prop="student_info.student_lst_nm">
                  <v-input
                    v-model="formData.student_info.student_lst_nm"
                    uppercase
                    :disabled="isCancel||isDisable" />
                </el-form-item>
              </div>

            </div>
            <div class="form-item form-half">
              <span>First Name</span>
              <el-form-item
                ref="student_info.student_fst_nm"
                :rules="!isRules?[]:rules.student_fst_nm"
                prop="student_info.student_fst_nm">
                <v-input
                  v-model="formData.student_info.student_fst_nm"
                  uppercase
                  :disabled="isCancel||isDisable" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Date of Birth</span>
              <el-form-item
                ref="student_info.student_dob"
                :rules="!isRules?[]:rules.student_dob"
                prop="student_info.student_dob">
                <v-birth-day
                  v-model="formData.student_info.student_dob"
                  :disabled="isCancel||isDisable"
                />
              </el-form-item>
            </div>
            <div class="form-half">
              <div class="form-item">
                <!--                <span>HKID Number</span>-->
                <span>{{formData.student_info.student_id_type==2?'Passport':'HKID'}} Number</span>
                <el-form-item
                  ref="id_type"
                >
                  <v-radio-group
                    v-model="formData.student_info.student_id_type"
                    :disabled="isCancel||isDisable"
                    :list="personalIdTypOptions" />
                </el-form-item>
                <el-form-item
                  v-if="formData.student_info.student_id_type==1"
                  ref="student_info.student_id_no"
                  :rules="!isRules?[]:rules.student_id_no"
                  prop="student_info.student_id_no"
                >
                  <!--                  <v-radio-group-->
                  <!--                    v-model="formData.id_type"-->
                  <!--                    :list="personalIdTypOptions" />-->
                  <!--                </el-form-item>-->
                  <!--                <el-form-item-->
                  <!--                  v-if="formData.id_type != 2"-->
                  <!--                  ref="id_no"-->
                  <!--                >-->
                  <v-input
                    v-model="formData.student_info.student_id_no"
                    uppercase
                    :disabled="isCancel||isDisable"
                    placeholder="A123456(3), please input A1234563"
                    class="mg-t-5" />
                </el-form-item>
                <el-form-item
                  v-else
                  ref="pp_no"
                >
                  <v-input
                    v-model="formData.student_info.student_id_no"
                    uppercase
                    :disabled="isCancel||isDisable"
                    class="mg-t-5" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Relationship to Policyholder</span>
                <el-form-item
                  ref="student_info.student_rel"
                  :rules="!isRules?[]:rules.student_rel"
                  prop="student_info.student_rel">
                  <v-select
                    v-model="formData.student_info.student_rel"
                    :disabled="isCancel||isDisable"
                    :list="localAllOptions.student_relation"/>
                </el-form-item>
              </div>
            </div>
            <div class="form-item form-half">
              <span>Overseas Studying Institution Name</span>
              <el-form-item
                ref="student_info.student_ins_nm"
                :rules="!isRules?[]:rules.student_ins_nm"
                prop="student_info.student_ins_nm">
                <v-input
                  v-model="formData.student_info.student_ins_nm"
                  :disabled="isCancel"
                />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Overseas Studying Institution Address</span>
              <el-form-item
                ref="student_info.student_addr"
                :rules="!isRules?[]:rules.student_addr"
                prop="student_info.student_addr">
                <v-input
                  v-model="formData.student_info.student_addr"
                  type="textarea"
                  :disabled="isCancel" />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="hasAcc"
            class="box">
            <h3>Optional Benefits Details</h3>
            <span class="title">Accompanying Parent or Guardian Details</span>

            <div class="form-item form-half">
              <span>Title</span>
              <el-form-item
                ref="acc_parent_info.accompanying_title"
                :rules="!isRules?[]:rules.accompanying_title"
                prop="acc_parent_info.accompanying_title">
                <v-select
                  v-model="formData.acc_parent_info.accompanying_title"
                  :disabled="isCancel"
                  :list="titleOptions" />
              </el-form-item>
            </div>
            <div class="flex-sb">
              <div class="form-item form-half">
                <span>Last Name</span>
                <el-form-item
                  ref="acc_parent_info.accompanying_lst_nm"
                  :rules="!isRules?[]:rules.accompanying_lst_nm"
                  prop="acc_parent_info.accompanying_lst_nm">
                  <v-input
                    v-model="formData.acc_parent_info.accompanying_lst_nm"
                    uppercase
                    :disabled="isCancel" />
                </el-form-item>
              </div>

            </div>
            <div class="form-item form-half">
              <span>First Name</span>
              <el-form-item
                ref="acc_parent_info.accompanying_fst_nm"
                :rules="!isRules?[]:rules.accompanying_fst_nm"
                prop="acc_parent_info.accompanying_fst_nm">
                <v-input
                  v-model="formData.acc_parent_info.accompanying_fst_nm"
                  uppercase
                  :disabled="isCancel||checkDisabled('accompanying_fst_nm')" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Date of Birth</span>
              <el-form-item
                ref="acc_parent_info.accompanying_dob"
                :rules="!isRules?[]:rules.accompanying_dob"
                prop="acc_parent_info.accompanying_dob">
                <v-birth-day
                  v-model="formData.acc_parent_info.accompanying_dob"
                  :disabled="isCancel"
                />
              </el-form-item>
            </div>
            <div class="form-half">
              <div class="form-item">
                <span>{{formData.acc_parent_info.accompanying_id_type==2?'Passport':'HKID'}} Number</span>
                <el-form-item
                  ref="id_type"
                >
                  <v-radio-group
                    v-model="formData.acc_parent_info.accompanying_id_type"
                    :disabled="isCancel"
                    :list="personalIdTypOptions" />
                </el-form-item>
                <el-form-item
                  v-if="formData.acc_parent_info.accompanying_id_type==1"
                  ref="acc_parent_info.accompanying_id_no"
                  :rules="!isRules?[]:rules.accompanying_id_no"
                  prop="acc_parent_info.accompanying_id_no"
                >
                  <v-input
                    v-model="formData.acc_parent_info.accompanying_id_no"
                    uppercase
                    :disabled="isCancel||checkDisabled('accompanying_id_no')"
                    placeholder="A123456(3), please input A1234563"
                  />
                </el-form-item>
                <el-form-item
                  v-else
                  ref="pp_no"
                >
                  <v-input
                    v-model="formData.acc_parent_info.accompanying_id_no"
                    uppercase
                    :disabled="isCancel||showBuyable||checkDisabled('accompanying_id_no')"
                    class="mg-t-5" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Relationship to Insured Student</span>
                <el-form-item
                  ref="acc_parent_info.accompanying_rel"
                  :rules="!isRules?[]:rules.accompanying_rel"
                  prop="acc_parent_info.accompanying_rel">
                  <v-select
                    v-model="formData.acc_parent_info.accompanying_rel"
                    :disabled="isCancel"
                    :list="localAllOptions.accompanying_relation"/>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="travel-box box">
            <h2>Upload Document</h2>
            <div
              v-if="editType==3"
              class="flex-sb">
              <div class="form-item form-half">
                <span >Renewal Letter（Insurer）</span>
                <el-form-item
                  ref="renewal_letter_insurer_path_id"
                  prop="renewal_letter_insurer_path_id">
                  <v-upload
                    :card="true"
                    ::disabled="isCancel||showBuyable"
                    :fileData="formData.renewal_letter_insurer"
                    :otherData="{
                      target: 'renewal_letter_insurer',
                      idKey: 'renewal_letter_insurer_path_id',
                      nameKey: 'renewal_letter_insurer_path',
                      type:'renewal_letter_insurer_path'
                    }"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess" />
                </el-form-item>
              </div>
            </div>
            <div class="flex">
              <div class="form-item form-half">
                <span>Policyholder HKID</span>
                <el-form-item prop="id_type_pic_path_id">
                  <v-upload
                    :card="true"
                    :disabled="isCancel||showBuyable"
                    :fileData="formData.id_type_pic"
                    :file-list="fileList"
                    :otherData="{
                      target: 'id_type_pic',
                      idKey: 'id_type_pic_path_id',
                      nameKey: 'id_type_pic_path',
                      type:'id_type_pic_path'
                    }"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </el-form-item>
              </div>
              <div class="form-item form-half">
                <span>Insured Student HKID </span>
                <!-- todo -->
                <el-form-item
                  ref="student_info.id_type_pic_path_id"
                  :rules="!isRules?[]:rules.id_type_pic_path_id"
                  prop="student_info.id_type_pic_path_id">
                  <v-upload
                    :disabled="isCancel||showBuyable"
                    :card="true"
                    :file-list="fileList"
                    :fileData="{
                      thumb_url:formData.student_info.id_type_pic_thumb_url,
                      url:formData.student_info.id_type_pic_url
                    }"
                    :otherData="{
                      type: 'student_id_type_pic',
                      idKey: 'id_type_pic_path_id',
                      nameKey: 'id_type_pic_path'
                    }"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </el-form-item>
              </div>
              <div
                v-if="hasAcc"
                class="form-item form-half">
                <span>Accompanying Parent or Guardian HKID </span>
                <el-form-item
                  ref="acc_parent_info.id_type_pic_path_id"
                  :rules="!isRules?[]:rules.id_type_pic_path_id"
                  prop="acc_parent_info.id_type_pic_path_id">
                  <v-upload
                    :disabled="isCancel||showBuyable"
                    :card="true"
                    :file-list="fileList"
                    :fileData="{
                      thumb_url:formData.acc_parent_info.id_type_pic_thumb_url,
                      url:formData.acc_parent_info.id_type_pic_url
                    }"
                    :otherData="{
                      type: 'acc_parent_id_type_pic',
                      idKey: 'id_type_pic_path_id',
                      nameKey: 'id_type_pic_path'
                    }"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </el-form-item>
              </div>
            </div>
          </div>

        </el-form>
      </div>
    </lazy-dom>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import AddressForm from '@/views/components/address-form'
import dayjs from 'dayjs'
import { getExtraCompute} from '@/api/order'
import MixinSame from '@/mixins/same'

export default {
  name: 'StudentPolicyForm',
  components: {
    AddressForm
  },
  mixins: [MixinOptions, MixinFormat, MixinRules,MixinSame],
  props: {
    form: {
      type: Object,
      default: null
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    isBenefitCoverage: {
      type: Boolean,//正常流程edit quote 勾选insured item 调用报价接口
      default: false
    },
    editQuote:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkBirth3 = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.formData
      const birth = dayjs(pcy_cmnt_dt).format('YYYY-MM-DD') || ( Date.now() + 1000 * 60 * 60 * 24)
      let msTime = new Date(value).getTime()
      let above18 = dayjs(value).add(18, 'year').format('YYYY-MM-DD')
      // if(msTime > Date.now()) {
      //   callback( new Error( '出生日期不得大於當前日期' ) )
      // }
      if(new Date(above18).getTime() > new Date(birth).getTime()) {
        callback( new Error('申請人必須年滿18歲' ) )
      }
      callback()
    }
    const checkOtherCoutry = (rule, value, callback) => {
      let {country_id} = this.formData
      if(country_id==3&&!value) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    return {
      formData: {
        renewal_letter_insurer_path: '',
        renewal_letter_insurer_path_id: '',
        renewal_letter_insurer: {},
        country_id: '',
        student_age:'',
        other_country:'',
        benefits:[],
        benefit_coverage:null,
        hldr_is_student_ind: 0,
        class_id: '',
        is_full_time:'',
        pcy_cmnt_dt: '',
        isrd_title: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        isrd_dob: '',
        isrd_dob_date: '',
        pcy_cmnt_date: '',
        pcy_expry_date: '',
        pcy_expry_dt: '',
        id_type: 1,
        id_no: '',
        mobile_no: '',
        occ_id:'',
        email: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        id_type_pic_path: '',
        id_type_pic_path_id: '',
        other_file: [],
        id_type_pic: {},
        accidental_death:'',
        acc_parent_info:{
          accompanying_dob:'',
          accompanying_rel:'',
          id_type_pic_path:'',
          id_type_pic_path_id:'',
          id_type_pic_url:'',
          id_type_pic_thumb_url:'',
          accompanying_id_no:'',
          accompanying_title:'',
          accompanying_fst_nm:'',
          accompanying_lst_nm:'',
          accompanying_id_type:'',
        },
        student_info:{
          student_dob:'',
          student_title:'',
          student_rel:'',
          student_lst_nm:'',
          student_fst_nm:'',
          student_id_type:1,
          student_id_no:'',
          student_ins_nm:'',
          student_addr:'',
          id_type_pic_path:'',
          id_type_pic_path_id:'',
          id_type_pic_thumb_url:'',
          id_type_pic_url:'',
        }
      },
      insAddressForm: {},
      formDataLock: 0,
      subForm: {
        'address-form': false,
      },
      otherData: {},
      addressForm: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      extraRules: {
        id_type_pic_path_id: [
          { required: false, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        isrd_dob:[
          { validator: checkBirth3, trigger: ['blur'] }
        ],
        other_country:[
          { validator: checkOtherCoutry, trigger: ['blur'] }
        ]
      }
    }
  },
  computed: {
    orderId(){
      let {id=''} = this.form||{}
      return id
    },
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      if(this.editQuote){
        arr = JSON.parse(JSON.stringify(this[`allOptions${this.formData.class_id}`].benefits))
      }else{
        kyc_benefit.some(item=>{
          // if(item.is_selected==1)
          //   this.formData.benefits.push(item.id)
          if(item.is_show!==0){
            arr.push({name:item.name,id:item.id})
          }
        })
      }
      return arr||[]
    },
    localAllOptions() {
      return this.allOptions25
    },
    insuredItems(){
      let {benefits=[]} = this.allOptions25
      return benefits||[]
    },
    expry_date(){
      let {pcy_cmnt_dt,benefits=[],pcy_expry_dt,pcy_period,ins_end_dt} = this.formData
      let end = ''
      if(pcy_period==0)
        end = pcy_expry_dt
      else
      {
        end=pcy_cmnt_dt? dayjs(pcy_cmnt_dt).add(pcy_period,'month').subtract(1,'day').format('YYYY-MM-DD'):''
        if(benefits.includes(1))
          end = dayjs(pcy_cmnt_dt).add(2,'year').subtract(1,'day').format('YYYY-MM-DD')
        else{
          end = dayjs(pcy_cmnt_dt).add(1,'year').subtract(1,'day').format('YYYY-MM-DD')
        }
      }
      if(this.isEndorsement)
        return  ins_end_dt?ins_end_dt:pcy_expry_dt

      this.formData.pcy_expry_dt = end
      return end
    },
    hasAcc() {
      const { benefits = [],benefit_coverage = {} } = this.formData
      // let {benefits=[]}= this.formData||{}
      let {acc_parent_guard_cvr=false} = benefit_coverage||{}
      return acc_parent_guard_cvr||this.isRefer&&benefits.includes(2)
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })


      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        // })
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
      // return this.rules
    },
    isRules(){
      return this.checkRefer ===2
    },
    isDisable(){
      return this.formData.hldr_is_student_ind==1
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          const formValue = JSON.parse(JSON.stringify(val))
          let {benefits=[]} =formValue||{}
          let {quote_coverage_list} = val||{}
          let {kyc_benefit=[]} = quote_coverage_list||{}
          kyc_benefit.some(item=>{
            if(item.is_selected==1)
              this.formData.benefits.push(item.id)
          })
          this.formData.benefits = [...new Set(this.formData.benefits)]
          let {student_info,acc_parent_info} = formValue||{}
          if(!student_info)
            delete formValue.student_info
          if(!acc_parent_info)
            delete formValue.acc_parent_info
          this.formData = Object.assign(
            this.formData,
            formValue
          )
          this.formData.benefits= [...new Set( this.formData.benefits)]
          // if(formValue.id_type != 1) {
          //   this.formData.id_no = ''
          // }
          if(formValue.id_type_pic) {
            const { path, id } = val.id_type_pic
            this.formData.id_type_pic_path = path
            this.formData.id_type_pic_path_id = id
          }
          this.handler().handlerAddress(formValue)
        }
      }
    },
    'form.benefit_coverage':{
      immediate:true,
      deep:true,
      handler(val){
        this.formData.benefit_coverage =val
      }
    }
  },
  methods: {
    handlerExtra(){
      let {extra_benefits,pcy_cmnt_dt,benefits} = this.formData
      let params = {
        extra_benefits,
        pcy_cmnt_dt,
        benefits
      }
      this.$emit('changeCompute',params)
      if(this.isBenefitCoverage)
      {
        params.order_id =this.orderId
        this.network().getExtraCompute(params)
      }
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      if(typeof(field) != 'string'){
        let res = false
        field.map(item => {
          if(disable_filed.includes(item)){
            res = true
          }
        })
        return res
      }
      return disable_filed.includes(field)&&!!this.form[field]
    },
    handlerSamePolicyInfo(){
      const {
        id_no, id_type, isrd_dob, isrd_fst_nm, isrd_lst_nm, isrd_title,
        id_type_pic,hldr_is_student_ind
      } = this.formData||{}

      const { id, client_name, path, url } = this.formData.id_type_pic || {}
      // 避免二次觸發 form 數據更新，影響 document 組件 司機數據
      if(hldr_is_student_ind == 1) {
        Object.assign(this.formData.student_info, {
          student_rel: 1,
          student_dob: isrd_dob,
          student_fst_nm: isrd_fst_nm,
          student_id_no: id_no,
          student_id_type: id_type,
          student_lst_nm: isrd_lst_nm,
          student_title: isrd_title,
          id_type_pic_path_id: id,
          id_type_pic_path: path,
          id_type_pic_url: url,
          id_type_pic_thumb_url: url,
        })
      }
    },
    submitForm(otherData = {}) {
      if(!this.hasAcc)
        delete this.formData.acc_parent_info
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.otherData = otherData
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if(Object.values(this.subForm).some(item => item === false)) {
            return
          }
          let {benefits=[]} = this.formData||{}
          const uniqueArray = benefits.filter((value, index, self) => {
            return self.indexOf(value) === index
          })
          const result = {
            ...this.formData,
            benefits:uniqueArray
          }
          this.$emit('getFormData', result, otherData)
        }     else {
          this.scrollToValidDom(rules)
        }
      })
    },
    getSaveSubmitForm(otherData = {}){
      this.otherData = otherData
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitFormNoVaild(key)
      })
      let {benefits=[]} = this.formData||{}
      const uniqueArray = benefits.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
      const result = {
        ...this.formData,
        benefits:uniqueArray
      }
      this.$emit('getFormData', result, otherData)

    },
    getAddressForm(form, data) {
      // debugger
      this.subForm[form] = true
      if(form == 'address-form') {
        this.formData = Object.assign(this.formData, data)
      }
      else {
        this.handler().handlerAddressResult(data)
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path,thumb_url,url } = data
      if(type !== 'other') {
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, nameKey, path)
        this.$set(this.formData, target, data)
        this.$refs['form'].validateField(idKey)
      }
      if(type == 'student_id_type_pic') {
        this.$set(this.formData.student_info, idKey, id)
        this.$set(this.formData.student_info, nameKey, path)
        this.$set(this.formData.student_info, 'id_type_pic_url', url)
        this.$set(this.formData.student_info, 'id_type_pic_thumb_url', thumb_url)
        // this.$set(this.formData, target, data)
      }
      if(type == 'acc_parent_id_type_pic') {
        this.$set(this.formData.acc_parent_info, idKey, id)
        this.$set(this.formData.acc_parent_info, nameKey, path)
        this.$set(this.formData.acc_parent_info, 'id_type_pic_url', url)
        this.$set(this.formData.acc_parent_info, 'id_type_pic_thumb_url', thumb_url)

        // this.$set(this.formData, target, data)
      }
      else {
        if(index === '') {
          this.formData.other_file.push(data)
        }
        else {
          this.$set(this.formData.other_file, index, data)
        }
      }
    },
    handlerDeleteFile({otherData}) {
      let { type, index,target,idKey,nameKey } = otherData
      if(type === 'student_id_type_pic') {
        this.$set(this.formData.student_info, 'id_type_pic_path_id', '')
        this.$set(this.formData.student_info, 'id_type_pic_path', '')
        this.$set(this.formData.student_info, 'id_type_pic_url', '')
        this.$set(this.formData.student_info, 'client_name', '')
        this.$set(this.formData.student_info, 'id_type_pic_thumb_url', '')
      }
      else if(type === 'acc_parent_id_type_pic'){
        this.$set(this.formData.acc_parent_info, 'id_type_pic_path_id', '')
        this.$set(this.formData.acc_parent_info, 'id_type_pic_path', '')
        this.$set(this.formData.acc_parent_info, 'id_type_pic_url', '')
        this.$set(this.formData.acc_parent_info, 'client_name', '')
        this.$set(this.formData.acc_parent_info, 'id_type_pic_thumb_url', '')
      }
      else{
        this.$set(this.formData, idKey, '')
        this.$set(this.formData, nameKey, '')
        this.$set(this.formData, target, {})
      }
    },
    network(){
      return{
        getExtraCompute: async params => {
          const {data} = await getExtraCompute(params)
          let {benefit_coverage} = data
          this.formData.benefit_coverage = benefit_coverage
        },
      }
    },
    handler() {
      return {
        handlerAddress: (data) => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const obj = {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          }
          // const params = {}
          // Object.keys(this.addressForm).some(key => {
          //   params[key] = data[key]
          // })
          this.formDataLock += 1
          this.addressForm = JSON.parse(JSON.stringify(obj))
          // this.corAddressForm = JSON.parse(JSON.stringify(obj))
        },
        handlerAddressResult: data => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const params = {
            cor_addr_room: addr_room,
            cor_addr_floor: addr_floor,
            cor_addr_block: addr_block,
            cor_addr_building: addr_building,
            cor_addr_street: addr_street,
            cor_addr_district: addr_district,
            cor_addr_area: addr_area,
            cor_addr_region: addr_region
          }
          Object.assign(this.formData, params)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-form {
  // width: 700px;
  .box {
    padding-bottom: 15px;
  }
  .travel-box{
    .flex{
      flex-wrap: wrap;
    }
  }
  .margin-top{
    margin-top: 10px;
  }
}
.extra_checkbox{
  ::v-deep .el-checkbox-group{
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
